export default [
  {
    path: '/activity-20260602-main',
    component: () => import('./Page.vue'),
    meta: { title: '台球争霸赛', id: 32 },
  },
  {
    path: '/activity-20260602-rule',
    component: () => import('./Rule.vue'),
    meta: { title: '台球争霸赛-规则', id: 32 },
  },
]
